import moment from "moment";

export type DateType = string | undefined | Date | moment.Moment;

/**
 * date 예외처리 및 포맷변환
 * @param date
 * @param format
 * @returns
 */
export const dateFormat = (date: DateType, format: string) =>
  moment(date).isValid() ? moment(date).format(format) : "-";
